/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ErrorBoundary.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date			  : Sep 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 30, 2019
 * Description   : ASDS-1419
 *
 * By            : Sandeep Raja
 * On            : Nov 15, 2019
 * Description   : ASDS-1829: Internal Server Message UI & Integration
 ******************************************************************************/

import React, { ReactNode } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import { logError } from "../../../utils/console-utility";

interface IErrorBoundaryProps extends RouteComponentProps {
  children?: ReactNode; // Add children here
}

interface IErrorState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    logError("Error: " + error.toString());
    logError("Error Info: " + errorInfo.componentStack);
  }

  render() {
    if (this.state.error) {
      return <ErrorPage />;
    } else {
      return this.props.children ? this.props.children : null;
    }
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary));